var exports = {
  "kL": "x0a7806d5--53f2a9--container",
  "wm": "x0a7806d5--53f2a9--logo",
  "nf": "x0a7806d5--53f2a9--link",
  "Ad": "x0a7806d5--53f2a9--foundation",
};

module.exports = exports;
